import { render, staticRenderFns } from "./InformationPush.vue?vue&type=template&id=c1ef19ca&scoped=true&"
import script from "./InformationPush.vue?vue&type=script&lang=js&"
export * from "./InformationPush.vue?vue&type=script&lang=js&"
import style0 from "./InformationPush.vue?vue&type=style&index=0&id=c1ef19ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ef19ca",
  null
  
)

export default component.exports